import axios from "axios";
import qs from "qs";

const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

interface AxiosError {
  response: AxiosResponse;
}

interface AxiosResponse {
  status: any;
  data: any;
}

const ajax = (method: string, url: string, requestData?: any, config?: any) => {
  return axios[method](url, requestData, config)
    .then((response: AxiosResponse) => {
      const { data } = response;
      if (data.error) {
        return Promise.reject(data.message);
      }
      return data.data ? data : { data };
    })
    .catch((err: AxiosError) => {
      try {
        return {
          error: err.response?.data.message ?? err.response?.data,
          status: err.response?.status,
        };
      } catch (e) {
        return { error: e.message };
      }
    });
};

const axiosAjax = {
  getApi: (url: string, data?: any) => {
    return axiosAjax.get(`${BASE_API_URL}${url}`, data);
  },
  postApi: (url: string, data?: any, config?: any) => {
    return axiosAjax.post(`${BASE_API_URL}${url}`, data, config);
  },
  putApi: (url: string, data?: any, config?: any) => {
    return axiosAjax.put(`${BASE_API_URL}${url}`, data, config);
  },
  get: (url: string, data?: any) => {
    return ajax("get", url, { params: data });
  },
  post: (url: string, data?: any, config?: any) => {
    return ajax("post", url, qs.stringify(data), config);
  },
  put: (url: string, data?: any, config?: any) => {
    return ajax("put", url, qs.stringify(data), config);
  },
};

export default axiosAjax;
